import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { getLocationDetail } from 'features/Location/services/location'
import { getOrderLocations } from 'features/Order/services/allOrder'
import { GetListDriverResponseType, getListDriverAPI } from 'features/Order/services/driver'
import { getOrderDetail } from 'features/Order/services/order'
import {
  formatNonWarehouseLocations,
  getNonWarehouseUserLocations,
} from 'features/Order/utils/ongoingOrders'
import { callErrorMsg } from 'helpers/errorMsg'
import type { RootStateType } from 'store'

export const SLICE_NAME = 'driverMonitoring'

export const fetchGetListLocation = createAsyncThunk(
  `${SLICE_NAME}/fetchGetListLocation`,
  async (_, { getState, rejectWithValue }) => {
    try {
      const { userData } = (getState() as RootStateType).auth

      if (!userData.isSuperAdmin) {
        const locations = getNonWarehouseUserLocations(userData)
        let initialLocation = null

        if (locations[0]) {
          try {
            const response = await getLocationDetail(locations[0].location_id)
            initialLocation = response.data
          } catch (err) {
            callErrorMsg(err)
          }
        }

        return { locations, initialLocation }
      }

      const response = await getOrderLocations()

      return {
        locations: formatNonWarehouseLocations(response.data.data),
        initialLocation: null,
      }
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetLocationDetail = createAsyncThunk(
  `${SLICE_NAME}/fetchGetLocationDetail`,
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getLocationDetail(id)

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetOrderDetail = createAsyncThunk(
  `${SLICE_NAME}/fetchGetOrderDetail`,
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getOrderDetail(id)

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetListDriver = createAsyncThunk(
  `${SLICE_NAME}/fetchGetListDriver`,
  async (params: Parameters<typeof getListDriverAPI>[0], { rejectWithValue }) => {
    try {
      const response: AxiosResponse<GetListDriverResponseType> = (await getListDriverAPI(
        params,
      )) as never

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
